import React from 'react';
import { FormattedMessage } from 'react-intl';
import { NotificationType } from '../../../utils/hooks/useNotificator/useNotificator.types';
import { GenericNotification } from './GenericNotification';

export const cantMoveHereNotification =
  () =>
  ({ notification }) =>
    (
      <GenericNotification
        notification={notification}
        text={<FormattedMessage id="files-manager.cant-move-here-notification" />}
        type={NotificationType.Destructive}
      />
    );
